import { BrowserRouter } from 'react-router-dom';
import { WebSocketProvider } from "./hooks/webSocketContext";
import AppRoutes from "./components/AppRoutes/AppRoutes";
import AnalyticsProvider from "./analytics/AnalyticsProvider";

import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

const AppShell = () => (
  <BrowserRouter>
    <AnalyticsProvider>
      <WebSocketProvider>
        <AppRoutes />
      </WebSocketProvider>
    </AnalyticsProvider>
  </BrowserRouter>
);

const App = () => {
  return (
    <div className="App">
      <AuthenticatedTemplate>
        <AppShell />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <AppShell />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default App;
